import React from 'react'

import BkFlowCurrencyToggle from '../../../currency/BkFlowCurrencyToggle'
import BkFlowNavigationDetailsToggle from '../elements/BkFlowNavigationDetailsToggle'

import yn from 'yn'
import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'

if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'currency') {
	require('../../../../styles/css/components/navigation/bk-flow-navigation-generic.css')
}

const BkFlowNavigationCurrency = props => {
	const {
		activeCurrencyData,
		configData,
		backButton,
		hotel,
		hotelPhone,
		hotelLogo,
		hotelLink,
		arrival,
		departure,
		guests,
		detailsExpanded,
		detailsEvent,
		exchangeRatesLoading,
		openEditModal
	} = props

	const hotelLabels = configData.hotel.labels[0]
	let headerClasses = 'bk-flow-header'

	if (
		yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION) &&
		yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES)
	) {
		headerClasses = 'bk-flow-header sticky inc-utility'
	} else if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
		headerClasses = 'bk-flow-header sticky'
	} else if (yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)) {
		headerClasses = 'bk-flow-header inc-utility'
	}

	return (
		<header role="banner">
			<div className={ headerClasses }>
				<div className="bk-flow-mobile-header container-fluid">
					<div className="row middle-xs">
						{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_BACK_BUTTON) && backButton(true) }

						{ process.env.REACT_APP_COMPONENT_NAVIGATION_MOBILE_BRANDING === 'logo' &&
							hotelLogo ?
								<div className="col-xs-8">
									<a
										className="bk-flow-navigation__logo-mobile"
										href={ hotelLink ? hotelLink : '/' }
										tabIndex={ 0 }
									>
										{ hotelLogo }
									</a>
								</div>
						:
							<h1 className="u-remove-margin col-xs-8">{ hotel }</h1>
						}

						<div className="bk-flow-mobile-header__call-btn col-xs-2">
							{ hotelPhone &&
								<a
									className="btn btn-text-only"
									href={ 'tel:' + hotelPhone }
									title="Call Now to Book"
								>
									<i className="material-icons">phone</i>
								</a>
							}
						</div>
					</div>
				</div>
				<nav>
					<div className="bk-flow-navigation bk-flow-navigation--currency">
						<div className="container-fluid u-remove-padding">
							<div className="row center-xs">
								<div className="bk-flow-navigation__room-details">

									<div className="container-fluid u-remove-padding">
										<div className="row">
											{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_BACK_BUTTON) && backButton(false) }

											{ hotelLogo &&
												<a
													className="bk-flow-navigation__logo u-mobile-hide-tablet-flex"
													href={ hotelLink ? hotelLink : '/' }
													tabIndex={ 0 }
												>
													{ hotelLogo }
												</a>
											}

											<div className="bk-flow-navigation__details col-xs">
												<div className="bk-flow-navigation__data row col-xs top-sm middle-xs">
													<div className="bk-flow-navigation__data-col column-md start-xs middle-xs">
														<p className="col-sm-12 u-font-bold">{ hotelLabels.arrival ? hotelLabels.arrival : 'Arrival' }:</p>
														<p className="col-sm-12 u-remove-margin">{ arrival }</p>
													</div>

													<div className="bk-flow-navigation__data-col column-md start-xs middle-xs">
														<p className="col-sm-12 u-font-bold">{ hotelLabels.departure ? hotelLabels.departure : 'Departure'}:</p>
														<p className="col-sm-12 u-remove-margin">{ departure }</p>
													</div>

													<div className="bk-flow-navigation__data-col column-sm start-xs u-mobile-hide-tablet-flex">
														<p className="col-sm-12 u-remove-margin u-font-bold">{ hotelLabels.guests ? hotelLabels.guests : 'Guests' }:</p>
														{ guests }
													</div>

													<div
														id="bk-toggle-edit-stay"
														className="bk-flow-navigation__edit-stay u-font-bold js-toggle__edit-stay"
														onClick={ openEditModal }
														tabIndex={0}
													>
														{ hotelLabels.editStay ? hotelLabels.editStay : 'Edit Stay' }
													</div>

													<div
														className="bk-flow-navigation__edit-stay-mobile btn btn-text-only u-font-bold"
														onClick={ openEditModal }
														tabIndex={ 0 }
													>
														{ hotelLabels.edit ? hotelLabels.edit : 'Edit'}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
									exchangeRatesLoading ?
									<BkFlowMaterialLoader
										parentClasses='bk-flow-navigation__currency-loader u-txt-center'
										color={'#000'}
										size={15}
									/>
								: yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
									activeCurrencyData &&
									activeCurrencyData.exchangeRate &&
									activeCurrencyData.currencyCode ?
									<BkFlowCurrencyToggle
										isMobile={ false }
										displayLabel={ true }
									/>
								:
									null
								}

								<BkFlowNavigationDetailsToggle
									hotelLabels={ hotelLabels }
									checked={ detailsExpanded }
									detailsEvent={ detailsEvent }
								/>
							</div>
						</div>
					</div>
				</nav>			
			</div>
		</header>
	)
}

export default BkFlowNavigationCurrency


// WEBPACK FOOTER //
// ./src/components/structure/navigation/layouts/BkFlowNavigationCurrency.js